export default {"src":"/_next/static/media/gq.ff56846a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};